export default __webpack_public_path__ + "static/media/walker2.54efb4fb.png";